"use strict";

import { Loader } from "@googlemaps/js-api-loader";

(() => {
	document.querySelectorAll(".acf-map")?.forEach(async (element) => {
		if (element instanceof HTMLElement) {
			const data = JSON.parse(element.dataset.map ?? "");
			const loader = new Loader({
				apiKey: element.dataset.apiKey ?? "",
				version: "weekly",
			});
			const maps_lib = await loader.importLibrary("maps");
			const marker_lib = await loader.importLibrary("marker");
			const position = {
				lat: data.lat ?? 0,
				lng: data.lng ?? 0,
			};
			const map = new maps_lib.Map(element, {
				center: position,
				mapId: element.dataset.mapId ?? "",
				zoom: data.zoom ?? 4,
			});
			const marker = new marker_lib.AdvancedMarkerElement({
				map,
				position,
			});
		}
	});
})();
